import {
	Typography,
	FormHelperText,
	Box,
	List,
	ListItem,
	ListItemText,
	ListItemIcon,
} from '@mui/material';
import { useState, useMemo } from 'react';
import CircleIcon from '@mui/icons-material/Circle';
import { QuestionCheckbox } from './questionCheckbox';
import { useQuoteContext } from '../../shared/contexts/QuoteContext';

/**
 * GeneralStatement component for presenting a General Statement for quotes.
 *
 * @param {object} props - Component props.
 * @param {boolean} props.generalStatementError - Indicates whether there's an error with the general statement.
 * @param {function} props.setShowGeneralStatementOfFact - Function to set the general statement state.
 * @returns {JSX.Element} - React JSX element representing the general statement section.
 */
const GeneralStatement = (props: any) => {
	// const [isChecked, setIsChecked] = useState<null | boolean>(null);

	// const { loadingProducts } = useQuoteContext();

	// const handleChange = (e: boolean) => {
	// 	setIsChecked(e);
	// 	props.setShowGeneralStatementOfFact(e);
	// 	props.setGeneralStatementError(!e);
	// };

	// const checkBoxes = useMemo(
	// 	() => [
	// 		{ label: "Yes", isChecked: isChecked === true, value: true },
	// 		{ label: "No", isChecked: isChecked === false, value: false },
	// 	],
	// 	[isChecked]
	// );

	const options = [
		'The Insured is not currently insured by Delta Insurance Australia.',
		'The Insured has not ever had any insurance declined or cancelled, renewal refused, special conditions imposed, or a claim rejected.',
		'No claim, proceeding or demand has been made or brought against the Insured or any of its directors, officer, or employees (whether insured or not) in the last 5 years.',
		'The Insured, after enquiry, is not aware of any act, error, omission, event, circumstance, or incident which may give rise to a claim, proceeding or demand, or any regulatory, administrative or governmental investigation or crime loss (whether insured or not).',
		'The Insured has not received any claims or complaints in respect of privacy, breach of information or network security, unauthorised disclosure of information or defamation content or infringement.',
		'The Insured or any of its directors, officers, or employees has not been the subject of any regulatory, administrative, or governmental investigation in the last 5 years (whether insured or not).',
		'The Insured has not been subject to a criminal conviction (excluding motor offences) or have any pending criminal matters awaiting a court hearing.',
		'I/We as the Insured confirm all the statements above to be true and accurate:',
	];

	return (
		<Box px='1.75em'>
			<Typography variant='subtitle2' style={{ whiteSpace: 'pre-line' }}>
				{
					'Please read the following statements and confirm their accuracy as indicated below for the proposed insurances the Insured is seeking cover for:'
				}
			</Typography>
			<List
				sx={{
					listStyle: 'upper-alpha',
					pl: 4,
					fontFamily: 'Poppins-Regular',
					fontSize: '14px',
				}}
				dense
			>
				{options.map((option, i) => (
					<ListItem sx={{ display: 'list-item' }} key={`general-statement-option-${i}`}>
						<ListItemText primary={option} />
					</ListItem>
				))}
			</List>

			{/* <Box pb="1em">
				{checkBoxes.map((t: any, index: number) => (
					<QuestionCheckbox
						key={`general-statement-q-${index}`}
						label={t["label"]}
						checked={!!t["isChecked"]}
						onChange={() => handleChange(t["value"])}
						disabled={loadingProducts}
					/>
				))}
				{props.generalStatementError && !isChecked && (
					<FormHelperText sx={{ ml: 0 }}>
						Please agree to the General Statement Of Fact to continue.
					</FormHelperText>
				)}
			</Box> */}
		</Box>
	);
};

export default GeneralStatement;
